import { MapPin, Phone, Clock, Instagram, Facebook, Music2 } from "lucide-react";
import { CONTACTS, MAP_EMBED, MAP_EMBED_PARK } from "@/data/content";
import { Reveal } from "@/components/Reveal";
import { FleurDivider } from "@/components/Ornament";

const ICONS = { Instagram, Facebook, Music2 };

const Column = ({ c, testid }) => (
  <div className="glass rounded-3xl p-6 sm:p-7" data-testid={testid}>
    <h4 className="font-cinzel text-amber-200 text-lg tracking-wider">{c.name}</h4>
    <div className="mt-4 space-y-2.5 text-sm text-slate-200/85">
      <div className="flex items-start gap-2.5">
        <MapPin className="w-4 h-4 text-amber-300 mt-0.5 shrink-0" />
        {c.address}
      </div>
      <a href={c.phoneHref} onClick={() => window.gtag_report_conversion && window.gtag_report_conversion()} className="flex items-center gap-2.5 hover:text-amber-300 transition-colors" data-testid={`${testid}-phone`}>
        <Phone className="w-4 h-4 text-amber-300 shrink-0" />
        {c.phone}
      </a>
      {c.socials.map((s) => {
        const Icon = ICONS[s.icon];
        return (
          <a
            key={s.href}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2.5 hover:text-amber-300 transition-colors"
            data-testid={`${testid}-social-${s.icon.toLowerCase()}`}
          >
            <Icon className="w-4 h-4 text-amber-300 shrink-0" />
            {s.label}
          </a>
        );
      })}
      <div className="flex items-center gap-2.5">
        <Clock className="w-4 h-4 text-amber-300 shrink-0" />
        Робочі години: {c.hours}
      </div>
    </div>
  </div>
);

const MapCard = ({ src, title, caption, testid }) => (
  <div data-testid={testid}>
    <div className="rounded-3xl overflow-hidden border border-amber-400/20 h-64 shadow-[0_16px_50px_rgba(0,0,0,0.45)]">
      <iframe
        title={title}
        src={src}
        className="w-full h-full grayscale-[35%] contrast-[1.05]"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
    <p className="mt-3 text-center text-xs sm:text-sm font-cinzel tracking-[0.14em] text-amber-200/80" data-testid={`${testid}-caption`}>
      {caption}
    </p>
  </div>
);

export default function Footer() {
  return (
    <footer id="kontakty" className="relative pt-16 pb-8 px-4 border-t border-amber-400/15" data-testid="site-footer">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <h3 className="font-display text-center text-3xl sm:text-4xl font-bold text-white" data-testid="footer-title">
            НАШІ <span className="text-gold-gradient">КОНТАКТИ</span>
          </h3>
        </Reveal>

        <div className="mt-10 grid md:grid-cols-2 gap-5">
          <Reveal delay={0.05}>
            <Column c={CONTACTS.park} testid="footer-park" />
          </Reveal>
          <Reveal delay={0.12}>
            <Column c={CONTACTS.royal} testid="footer-royal" />
          </Reveal>
        </div>

        <div className="mt-5 grid md:grid-cols-2 gap-5">
          <Reveal delay={0.15}>
            <MapCard
              src={MAP_EMBED_PARK}
              title="Карта проїзду — Park Kids Club"
              caption="PARK KIDS CLUB — Lazarya Hloby St, 4"
              testid="footer-map-park"
            />
          </Reveal>
          <Reveal delay={0.2}>
            <MapCard
              src={MAP_EMBED}
              title="Карта проїзду — Royal Kids Club"
              caption="ROYAL KIDS CLUB — Oleksandra Koniskoho St, 37"
              testid="footer-map-royal"
            />
          </Reveal>
        </div>

        <div className="mt-12 text-center">
          <FleurDivider id="ornFooter" className="mb-7" />
          <div className="font-cinzel text-xl sm:text-2xl tracking-[0.25em] text-gold-gradient inline-block" data-testid="footer-brand">
            PARK × ROYAL KIDS CLUB
          </div>
          <p className="mt-3 text-sm text-amber-100/70" data-testid="footer-slogan">ДВА СВІТИ. ОДНА ТУРБОТА.</p>
          <div className="mt-6 h-px w-48 mx-auto bg-gradient-to-r from-transparent via-amber-400/50 to-transparent" />
          <p className="mt-6 text-xs text-slate-400/70" data-testid="footer-copyright">
            © 2026 PARK × ROYAL KIDS CLUB. Усі права захищено.
          </p>
        </div>
      </div>
    </footer>
  );
}
